const Questions = [
  {
    qusText: "Who is the Prime Minister of India?",
    qusOptions: [
      { ansText: "Dr. Manmohan Singh", isCorrect: false },
      { ansText: "Sri Narendra Modi", isCorrect: true },
      { ansText: "Sri Amit shah", isCorrect: false },
      { ansText: "Yogi Aditya Nath", isCorrect: false },
    ],
  },{
    qusText: "Who is the Home Minister of India?",
    qusOptions: [
      { ansText: "Sri Rajnath Singh", isCorrect: false },
      { ansText: "Yogi Aditya Nath", isCorrect: false },
      { ansText: "Sri Narendra Modi", isCorrect: false },
      { ansText: "Sri Amit shah", isCorrect: true },
    ],
  },{
    qusText: "Who is the Finanece Minister of India?",
    qusOptions: [
      { ansText: "Dr. Manmohan Singh", isCorrect: false },
      { ansText: "Sri-Mati Niramla SitaRaman", isCorrect: true },
      { ansText: "Sri Amit shah", isCorrect: false },
      { ansText: "Dr. Arun Jetali", isCorrect: false },
    ],
  },{
    qusText: "Who is the Defence Minister of India?",
    qusOptions: [
      { ansText: "Dr. Manmohan Singh", isCorrect: false },
      { ansText: "Sri Narendra Modi", isCorrect: false },
      { ansText: "Sri Amit shah", isCorrect: false },
      { ansText: "Sri Rajnath Singh", isCorrect: true },
    ],
  },{
    qusText: "Who is the Foriegn Minister of India?",
    qusOptions: [
      { ansText: "Dr. JaiShankar", isCorrect: true },
      { ansText: "Sri Narendra Modi", isCorrect: false },
      { ansText: "Sri Amit shah", isCorrect: false },
      { ansText: "Sri Rajnath Singh", isCorrect: false },
    ],
  },{
    qusText: "Who is the Chief Minister of Uttar Pradesh?",
    qusOptions: [
      { ansText: "Yogi Aditya Nath", isCorrect: true },
      { ansText: "Sri Narendra Modi", isCorrect: false },
      { ansText: "Sri Amit shah", isCorrect: false },
      { ansText: "Sri Rajnath Singh", isCorrect: false },
    ],
  },{
    qusText: "Who is the Chief Justice of India?",
    qusOptions: [
      { ansText: "Sri Ranjan Gogai", isCorrect: false },
      { ansText: "Sri Narendra Modi", isCorrect: false },
      { ansText: "Sri Amit shah", isCorrect: false },
      { ansText: "Uday Umesh Lalit", isCorrect: true },
    ],
  },{
    qusText: "Who is the present speaker of Lok Sabha?",
    qusOptions: [
      { ansText: "Meera Kumar", isCorrect: false },
      { ansText: "Ramnath Kovind", isCorrect: false },
      { ansText: "Om birla", isCorrect: true },
      { ansText: "Ramvilas Paswan", isCorrect: false },
    ],
  },
  {
    qusText: "Who is selected as the 14th President of India?",
    qusOptions: [
      { ansText: "Ram Nath Kovind", isCorrect: true },
      { ansText: "Suresh Kumar", isCorrect: false },
      { ansText: "Rajesh kumar", isCorrect: false },
      { ansText: "Meira kumar", isCorrect: false },
    ],
  },{
    qusText: "Which union minister has launched PowerTex India scheme to boost powerloom sector?",
    qusOptions: [
      { ansText: "Narendra Modi", isCorrect: false },
      { ansText: "Smriti Irani", isCorrect: true },
      { ansText: "Rajnath Singh", isCorrect: false },
      { ansText: "Arun Jaitley", isCorrect: false },
    ],
  },
  
];

export default Questions